<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>

            <v-text-field v-model="filter.code" label="Proforma ID" class="mr-3"></v-text-field>

            <v-autocomplete v-model="filter.status" :items="statuses" item-text="title" item-value="id" label="Status" class="mr-3"></v-autocomplete>
            
            <autocomplete v-model="filter.type" :items="types" label="Type" />

            <autocomplete v-if="filter.type == config.invoiceTypes.customer" v-model="filter.customer" async api-path="customer" sub-title="mobile" clearable label="Customer Name" />

            <autocomplete v-if="filter.type == config.invoiceTypes.customer" v-model="filter.customer" async api-path="customer" search-key="mobile" sub-title="title" clearable label="Customer Mobile" />

            <autocomplete v-if="filter.type == config.invoiceTypes.franchisee" label="Franchisee Name" v-model="filter.franchisee" async api-path="retailer-search" clearable />

            <search-btn @click="filterData" />

            <v-spacer></v-spacer>
              <v-btn v-if="hasCreateAccess" to="/proforma-invoice" round color="primary" dark small class="ml-4">Add New</v-btn>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="invoice-list-item" :item="props.item" @confirm="openConfirmDialog" @cancel="confirmCancelItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

      <action-dialog action="cancel" :status="cancelDialog" @close="closeCancelDialog" @success="cancelInvoice" />
      <action-dialog action="confirm" :status="confirmDialog" @close="closeConfirmDialog" @success="confirmInvoice" />

   	</v-layout>
    
  </v-flex>
</template>

<script>

  import InvoiceListItem from './InvoiceListItem'

  export default {
    name: 'InvoiceList',
    data () {
      return {
      	title: "Proforma Invoice List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'Proforma ID', value: 'code'},
          { text: 'Date', value: 'added_time'},
          { text: 'Type', value: 'type', sortable: false},
          { text: 'Customer/Franchisee', value: 'customer_name', sortable: false},
          { text: 'Branch', value: 'retailer_name'},
          // { text: 'Sub Total (Rs.)', value: 'total', align: 'right'},
          // { text: 'Discount (Rs.)', value: 'discount', align: 'right'},
          // { text: 'GST (Rs.)', value: 'tax', align: 'right'},
          { text: 'Total (Rs.)', value: 'grandtotal', align: 'right'},
          { text: 'Status', value: 'status', align: 'center', sortable: false },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        cancellingItem: null,
        cancelDialog: false,
        confirmingItem: null,
        confirmDialog: false,
        filter: {
          type: "",
          code: "",
          customer: "",
          franchisee: "",
          status: ""
        },
        types: [
          {
            id: "",
            title: "All"
          }
        ],
        statuses: [
          {
            id: "",
            title: "All"
          }
        ],
        customerLoading: false,
        customerSearchText: "",
        customerSearchMobile: "",
        customers: [],
        franchiseeLoading: false,
        franchiseeSearchText: "",
        franchisees: []
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Proforma Invoice',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Proforma Invoice')

      for (const [key, val] of Object.entries(this.config.invoiceStatus)) {
        this.statuses.push({id: val, title: key})
      }

    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getInvoices.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          if (val || val === this.config.invoiceStatus.pending) {
            filterArray.push(`${key}=${val}`)
          }
        }

        if (filterArray.length) {
          api_path += '?' + filterArray.join('&')
        }

        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      searchCustomers (params) {
        
        let api_path = this.config.apis.getCustomers.replace(":page", 1).replace(":perPage", this.paginationOptions.rowsPerPage)

        api_path += params

        this.customerLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.customerLoading = false
            if (this.isSuccessResponse(response)) {
              this.customers = response.data.data.items
            }
        })
        .catch((error) => {
            this.customerLoading = false
        })

      },

      searchCustomersByName () {

        let param = `?title=${this.customerSearchText}`

        this.searchCustomers(param)

      },

      searchCustomersByMobile () {

        let param = `?mobile=${this.customerSearchMobile}`

        this.searchCustomers(param)
      },

      searchFranchisees () {
        this.franchiseeLoading = true
        this.axios.get(`${this.config.apis.searchRetailers}?title=${this.franchiseeSearchText}`)
        .then((response) => {
            this.franchiseeLoading = false
            if (this.isSuccessResponse(response)) {
              this.franchisees = response.data.data
            }
        })
        .catch((error) => {
            this.franchiseeLoading = false
        })
      },

      confirmCancelItem (item) {
        this.cancellingItem = item
        this.cancelDialog = true
      },

      closeCancelDialog () {
        this.cancellingItem = null
        this.cancelDialog = false
      },

      openConfirmDialog (item) {
        this.confirmingItem = item
        this.confirmDialog = true
      },

      closeConfirmDialog () {
        this.confirmingItem = null
        this.confirmDialog = false
      },

      cancelInvoice () {
        
        if (!this.cancellingItem) return

        this.processing = true
        this.axios.put(this.config.apis.cancelInvoice.replace(":id", this.cancellingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.cancellingItem.status = this.config.invoiceStatus.cancelled

              this.notifySuccess('updateSuccess')
              this.closeCancelDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeCancelDialog()
          })
      },

      confirmInvoice () {
        
        if (!this.confirmingItem) return

        this.processing = true
        this.axios.put(this.config.apis.confirmInvoice.replace(":id", this.confirmingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.confirmingItem.status = this.config.invoiceStatus.confirmed

              this.notifySuccess('updateSuccess')
              this.closeConfirmDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeConfirmDialog()
          })
      }

    },
    mounted () {
      
      for (const [key, val] of Object.entries(this.config.invoiceTypes)) {
        this.types.push({id: val, title: key})
      }

    },

    computed: {

    },

    watch: {

      customerSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchCustomersByName()
        }
      },

      customerSearchMobile (val, oldVal) {
        if (val && val != oldVal) {
          this.searchCustomersByMobile()
        }
      },

      franchiseeSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchFranchisees()
        }
      },

      'filter.type' () {
        this.filter.customer = ""
        this.filter.franchisee = ""
      }

    },
    
    components: {
      'invoice-list-item': InvoiceListItem
    }

  }
</script>
